export default __webpack_public_path__ + "static/media/b5.1d8324b2.jpg";